import React from 'react';

const DateInput = React.forwardRef((props: object, ref?: React.LegacyRef<HTMLInputElement>) => (
    <div className="text-input">
        <input ref={ref} {...props} className="text-input__input" />
    </div>
));

export default DateInput;
